import { Navigate } from "react-router-dom";
import { isAuthenticated } from "../services/auth";

function AdminRoute({ children }) {
  const isLoggedIn = isAuthenticated();

  if (!isLoggedIn) {
    return <Navigate to="/admin/login" />;
  }

  return children;
}

export default AdminRoute;
